export function Logout () {
  localStorage.removeItem('__cbu');
  window.location.href = "/login"
}
